import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { AuthenticationContext, logUserIn } from "@cloudmlm/cloudmlm-auth";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  Stack,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Menu,
  MenuItem,
} from "@mui/material";
import dataConstant from "../../constants/dataConstants";
import urlConstant from "../../constants/urlConstants";
import {
  DecryptData,
  encryptData,
  httpGet,
  httpPost,
} from "../../services/commonService";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import {
  nameValidator,
  whiteSpaceValidator,
} from "../../shared-components/validator/fieldValidator";
import CustomPhoneField from "../../shared-components/form-controls/customPhoneField";
import CustomAutoCompleteDropdown from "../../shared-components/form-controls/customAutoCompleteDropdown";
import CustomTextField from "../../shared-components/form-controls/customTextField";
import { endApiLoader, startApiLoader } from "../../services/apiLoaderService";
import SignupCompletePopup from "../../shared-components/custom-popup/SignupCompletePopup";
import FreeSignupNotValidFormPopup from "../../shared-components/custom-popup/FreeSignupNotValidFormPopup";
import i18n from "../../i18n";
import GoogleTranslate from "../../shared-components/google-translate/googleTranslate";

let acctID = 0;
let userID = "";
const locales = {
  en: { title: "English" },
  es: { title: "Spanish" },
};
const IBOFreeBYLDerSignup = () => {
  const authenticationState = useContext(AuthenticationContext);
  const { t } = useTranslation();
  const currentLang = i18n.language;
  const location = useLocation();
  const [snack, closeSnack, showSnackbar] = SnackState();
  const navigate = useNavigate();
  const [state, setState] = useState({
    signupModel: false,
    invalidFormModel: false,
    isValidSignupPage: false,
    isAPICalled: false,
    RefAccountSiteName: "",
    selectedPackageName: "",
    packageName: "",
    packageTotalAmount: 0,
    countryId: 0,
    itemSubscriptionPrice: 0,
    isAllDropDownCalled: false,
    IBOSignupUserInfo: {
      uniqueURL: "",
      RefAccountId: "",
      fullName: "",
      state: {},
      country: {},
      iWalletBalance: 0,
      countryData: [],
      stateData: [],
    },
    phoneCountryCodeList: [],
  });
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [isPhoneFiledForceUpdate, setIsPhoneFiledForceUpdate] = useState(true);
  const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const recaptchaSiteKey = `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;

  const methods = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      replicaSiteName: "",
      address: "",
      city: "",
      state: null,
      country: null,
      zipcode: "",
      password: "",
      confirmPassword: "",
    },
  });
  const { handleSubmit, setValue, watch, trigger, setFocus, control } = methods;
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");
  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    setRecaptchaError(false);
  };

  const handlelanguageClick = (event) => {
    setAnchorElLanguage(event.currentTarget);
  };

  const handleLanguageClose = (lang) => {
    setAnchorElLanguage(null);
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  useEffect(() => {
    const repURL = window.location.pathname.split("/").filter(Boolean);
    const userId = repURL[1];
    httpGet(
      `${urlConstant.IBOSignup.GetReplicationDetails}?userId=${userId}`,
      false,
      true
    ).then((response) => {
      if (response.Status === "Success") {
        if (response.Value.IsFreeBylder) {
          setState((prevState) => ({
            ...prevState,
            selectedPackageName: response.Value.PackageType,
            packageName: response.Value.PackageName,
            isAPICalled: true,
            isValidSignupPage: true,
            RefAccountSiteName: response.Value.ReplicaName,
            countryId: 1,
            itemSubscriptionPrice: response.Value.ItemSubscriptionPrice,
            IBOSignupUserInfo: {
              ...prevState.IBOSignupUserInfo,
              RefAccountId: response.Value.RepId,
              fullName: response.Value.FullName,
            },
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            isValidSignupPage: false,
            invalidFormModel: true,
            isAPICalled: true,
            RefAccountSiteName: response.Value.ReplicaName,
          }));
        }
      } else {
        setState((prevState) => ({
          ...prevState,
          isValidSignupPage: false,
          isAPICalled: true,
          invalidFormModel: true,
        }));
      }
    });
  }, []);

  useEffect(() => {
    if (state.packageName !== "") {
      getAllDropDownList();
    }
  }, [state.packageName]);

  useEffect(() => {
    if (confirmPassword) {
      trigger("confirmPassword");
    }
  }, [password, trigger]);

  useEffect(() => {
    if (state.isAllDropDownCalled) {
      getStateDropDownList(state.countryId);
    }
  }, [state.isAllDropDownCalled]);

  useEffect(() => {
    if (state.IBOSignupUserInfo.RefAccountId !== "") {
      setFocus("firstName");
    }
  }, [state.IBOSignupUserInfo.RefAccountId]);

  const closeInValidFormLoginPopup = () => {
    setState((prevState) => ({
      ...prevState,
      invalidFormModel: false,
    }));
    navigate("/login");
  };

  const closeInValidFormSignupPopup = () => {
    setState((prevState) => ({
      ...prevState,
      invalidFormModel: false,
    }));
    navigate("/IBOSignup/BYLDer");
  };

  const getAllDropDownList = () => {
    const dropDownTypes = [dataConstant.AllDropDown.CoutryDropDown];
    const model = {
      DropDownTypes: _.join(dropDownTypes, ","),
    };
    httpPost(urlConstant.Common.GetAllDropDownList, model, true)
      .then((response) => {
        const countryList = response.Value.CoutryDropDownResult.Data;
        const getCountryData = _.find(
          countryList,
          (item) => item.value === state.countryId
        );
        setState((prevState) => ({
          ...prevState,
          isAllDropDownCalled: true,
          IBOSignupUserInfo: {
            ...prevState.IBOSignupUserInfo,
            countryData: countryList,
            country: getCountryData !== undefined ? getCountryData : {},
          },
          phoneCountryCodeList: countryList
            .filter((item) => !item.isDisabled)
            .map((item) => item.countryCode?.toLowerCase?.() || ""),
        }));
        if (getCountryData !== undefined) {
          setValue("country", getCountryData);
        }
        setIsPhoneFiledForceUpdate(!isPhoneFiledForceUpdate);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  };

  const getStateDropDownList = async (countryId, stateId = 0) => {
    if (countryId !== null) {
      await httpGet(
        `${urlConstant.Common.GetStateList}?CountryId=${countryId}`,
        true
      )
        .then((response) => {
          let stateValue = null;
          if (stateId !== 0) {
            stateValue = _.find(response.Value.Data, (i) => {
              return i.value === stateId;
            });
          }
          setState((prevState) => ({
            ...prevState,
            IBOSignupUserInfo: {
              ...prevState.IBOSignupUserInfo,
              stateData: response.Value.Data,
              state: stateValue === null ? {} : stateValue,
            },
          }));
          setValue("state", stateValue);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {});
    }
  };

  const handleCountryChange = (value) => {
    if (value) {
      getStateDropDownList(value.value);
    }
  };

  const formConfig = {
    firstNameParamValueId: {
      name: "firstName",
      label: t("PublicInfo.First Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.First Name"),
      },
    },
    lastNameParamValueId: {
      name: "lastName",
      label: t("PublicInfo.Last Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.Last Name"),
      },
    },
    emailParamValueId: {
      name: "email",
      label: t("PublicInfo.Email Address"),
      isDisabled: location.state?.upgrade,
      type: "email",
      maxLength: 100,
      required: true,
    },
    replicaSiteNameParamValueId: {
      name: "replicaSiteName",
      label: t("SignupCommonField.Common.ReplicatedWebsiteName"),
      isDisabled: location.state?.upgrade,
      type: "text",
      maxLength: 100,
      className: "cm-sitename",
      required: true,
      validation: {
        validate: nameValidator(
          "SignupCommonField.Common.ReplicatedWebsiteName"
        ),
      },
    },
    addressParamValueId: {
      name: "address",
      label: t("SignupCommonField.Common.Address"),
      type: "text",
      maxLength: 200,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.Address"),
      },
    },
    cityParamValueId: {
      name: "city",
      label: t("SignupCommonField.Common.City"),
      type: "text",
      maxLength: 100,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.City"),
      },
    },
    stateParamValueId: {
      name: "state",
      label: t("SignupCommonField.Common.State"),
      dropDownList: state.IBOSignupUserInfo.stateData,
      required: true,
    },
    countryParamValueId: {
      name: "country",
      label: t("SignupCommonField.Common.Country"),
      dropDownList: state.IBOSignupUserInfo.countryData,
      required: true,
      customOnChange: handleCountryChange,
    },
    zipcodeParamValueId: {
      name: "zipcode",
      label: t("SignupCommonField.Common.ZipCode"),
      type: "text",
      maxLength: 10,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.ZipCode"),
      },
    },
    passwordParamValueId: {
      name: "password",
      label: t("SignupCommonField.Common.Password"),
      type: "password",
      maxLength: 100,
      required: true,
    },
    confirmPasswordParamValueId: {
      name: "confirmPassword",
      label: t("SignupCommonField.Common.ConfirmPassword"),
      type: "password",
      maxLength: 100,
      required: true,
      validation: {
        validate: (value) =>
          value === password ||
          t(
            "SignupCommonField.Common.Password and confirm password does not match"
          ),
      },
    },
  };

  const onSubmit = (event) => {
    if (!recaptchaValue) {
      setRecaptchaError(true);
      return;
    }

    const model = {
      UserID: userID,
      FirstName: event.firstName,
      LastName: event.lastName,
      Email: event.email.toLowerCase(),
      RefAcctID: state.IBOSignupUserInfo.RefAccountId,
      ReplicatedSite: event.replicaSiteName,
      Password: encryptData(event.password),
      PackageType: state.selectedPackageName,
      CountryID: event.country
        ? event.country[0]
          ? event.country[0].value
          : event.country.value
        : null,
      PhoneNumber: event.phoneNumber.fullNumber,
      Address: event.address,
      City: event.city,
      StateID: event.state ? event.state.value : null,
      Zipcode: event.zipcode,
      RecaptchaResponse: recaptchaValue,
    };
    const upgradeURL = urlConstant.IBOSignup.CheckoutProcess;
    httpPost(upgradeURL, model, true)
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          setState((prevState) => ({
            ...prevState,
            signupModel: true,
          }));
          localStorage.setItem("email", event.email.toLowerCase());
          localStorage.setItem("password", encryptData(event.password));
        } else if (
          response.Status === dataConstant.APIResponseStatus.Failure &&
          response?.error === dataConstant.FreeSignupUrlExpired
        ) {
          setState((prevState) => ({
            ...prevState,
            isValidSignupPage: false,
            invalidFormModel: true,
          }));
        } else {
          showSnackbar(response.error, "error");
          return response.error;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDashboard = () => {
    setState((prevState) => ({
      ...prevState,
      signupModel: false,
    }));
    if (acctID > 0) {
      if (location.state?.upgrade === true) {
        navigate("/order");
      } else {
        navigate("/home");
      }
    } else {
      const autoLoginCredentials = {
        username: localStorage.getItem("email"),
        password: DecryptData(localStorage.getItem("password")),
        tokenUrl: process.env.REACT_APP_ROPC_TOKEN_URL,
        grantType: "password",
        scope: `${process.env.REACT_APP_AZURE_AD_B2C_SCOPE} openid offline_access`,
        clientId: process.env.REACT_APP_AZURE_AD_B2C_CLIENTID,
        responseType: "token",
      };
      startApiLoader();
      logUserIn(autoLoginCredentials)
        .then((result) => {
          authenticationState.logUserIn(result);
          const authObject = JSON.parse(localStorage.getItem("auth"));
          if (authObject !== dataConstant.Undefined && authObject !== null) {
            localStorage.setItem("InitialToken", authObject.accessToken);
          }
          endApiLoader();
          navigate("/home");
          console.log("Auto-login successful");
        })
        .catch((e) => {
          console.error("Auto-login failed:", e);
        });
    }
  };

  return (
    <>
      {state.isAPICalled && state.isValidSignupPage && (
        <Box flexDirection={"column"} gap={2} display={"flex"}>
          <Box width={"100%"}>
            <Card
              sx={(theme) => ({
                p: {
                  xs: "20px",
                  sm: "25px 30px",
                },
                background: "rgba(var(--black-rgb), 0.2)",
                backdropFilter: "blur(50px)",
                border: "1px solid var(--headerbg)",
                borderRadius: "20px",
                borderTopLeftRadius: "0",
                borderTopRightRadius: "0",
                height: "100%",
              })}
            >
              <Stack gap={"20px"}>
                <Grid container spacing={2}>
                  <Stack
                    gap={2}
                    direction={"row"}
                    flexWrap={"wrap"}
                    alignItems={"center"}
                  >
                    <img
                      src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/logo-header.svg`}
                      alt="logo"
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handlelanguageClick}
                    >
                      {currentLang.toUpperCase()}
                    </Button>
                    <Typography
                      color="secondary.light"
                      variant="h4"
                      fontWeight={600}
                    >
                      BYLDer Enrollment Program |
                    </Typography>
                    <Typography variant="h4" color="primary.main">
                      {t("SignupCommonField.Common.IBOName")}{" "}
                      {state.RefAccountSiteName}
                    </Typography>
                  </Stack>
                </Grid>
              </Stack>
            </Card>
          </Box>
          <Grid
            container
            spacing={3}
            sx={{ flexGrow: 1, marginBottom: "25px" }}
          >
            <Grid mx={"auto"} size={{ xs: 12, sm: 10 }}>
              <Card
                sx={(theme) => ({
                  p: {
                    xs: "20px",
                    sm: "25px 30px",
                  },
                  background: theme.palette.background.cardGradient,
                  border: "1px solid var(--headerbg)",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                })}
              >
                <Stack gap={1}>
                  <Typography variant="h4" fontWeight={800} color="primary">
                    {t("SignupCommonField.IBOSignup.WelcomeTitle")}
                  </Typography>
                  <Typography variant="body1" color="secondary.light">
                    {t("SignupCommonField.IBOSignup.WelcomeNote1")}
                  </Typography>
                </Stack>

                <Typography
                  variant="h5"
                  fontWeight={800}
                  color="secondary.light"
                >
                  {t("SignupCommonField.Common.ContactInformation")}
                </Typography>

                <form noValidate onSubmit={handleSubmit(onSubmit)}>
                  <Stack gap={"20px"}>
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.firstNameParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.lastNameParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.emailParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomPhoneField
                          control={control}
                          isPhoneFiledForceUpdate={isPhoneFiledForceUpdate}
                          name="phoneNumber"
                          label={t("PublicInfo.Phone Number")}
                          required={true}
                          countryList={state.phoneCountryCodeList}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <Stack
                          className="customfield-label"
                          sx={{
                            maxWidth: "700px",
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          <CustomTextField
                            methods={methods}
                            properties={formConfig.replicaSiteNameParamValueId}
                          />
                          <Card
                            className="customfield-label-inner"
                            sx={{
                              marginTop: "21px",
                              display: {
                                xs: "none !important",
                                sm: "flex !important",
                              },
                            }}
                          >
                            {process.env.REACT_APP_BYLD_DOMAIN_NAME}
                          </Card>
                        </Stack>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "10px" }}
                          color="secondary.main"
                        >
                          {t("SignupCommonField.Common.ReplicaNoteMessage")}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          methods={methods}
                          properties={formConfig.countryParamValueId}
                        />
                      </Grid>
                      {!location.state?.upgrade && (
                        <>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <CustomTextField
                              methods={methods}
                              properties={formConfig.passwordParamValueId}
                            />
                          </Grid>
                          <Grid size={{ xs: 12, sm: 6 }}>
                            <CustomTextField
                              methods={methods}
                              properties={
                                formConfig.confirmPasswordParamValueId
                              }
                            />
                          </Grid>
                        </>
                      )}
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.addressParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomAutoCompleteDropdown
                          methods={methods}
                          properties={formConfig.stateParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.cityParamValueId}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.zipcodeParamValueId}
                        />
                      </Grid>
                    </Grid>

                    <Typography
                      variant="h6"
                      fontWeight={800}
                      color="secondary.light"
                    >
                      {t("SignupCommonField.IBOSignup.PackageDetails")}{" "}
                      {state.packageName} ${state.packageTotalAmount}{" "}
                      <Typography fontWeight={400} variant="span">
                        {t("SignupCommonField.IBOSignup.OneTime")}{" "}
                        {t("SignupCommonField.Common.then")} ${state.itemSubscriptionPrice}{" "}
                        {t("SignupCommonField.Common.billedmonthly")}
                      </Typography>
                    </Typography>

                    <Controller
                      name="terms"
                      control={control}
                      rules={{
                        required: t(
                          "SignupCommonField.Common.CheckboxRequired"
                        ),
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <Stack direction={"column"} alignItems={"flex-start"}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={!!field.value}
                                color="primary"
                              />
                            }
                            label={
                              <Typography variant="body2" color="secondary">
                                {t(
                                  "SignupCommonField.IBOSignup.CheckboxTermCondition"
                                )}{" "}
                                <Link
                                  href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/IBOTermsAndConditions.pdf`}
                                  underline="hover"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  fontWeight={600}
                                >
                                  {t(
                                    "SignupCommonField.IBOSignup.TermsAndConditions"
                                  )}
                                </Link>
                              </Typography>
                            }
                          />
                          {error && (
                            <FormHelperText sx={{ mt: "0px" }} error>
                              {error.message}
                            </FormHelperText>
                          )}
                        </Stack>
                      )}
                    />
                    <Stack direction={"column"} gap={0}>
                      <ReCAPTCHA
                        sitekey={recaptchaSiteKey}
                        onChange={handleRecaptchaChange}
                      />
                      {recaptchaError && (
                        <Typography sx={{ fontSize: "12px" }} color="error">
                          {t(
                            "SignupCommonField.AffiliateSignUp.RecaptchaError"
                          )}
                        </Typography>
                      )}
                    </Stack>
                    <Stack
                      direction={"row"}
                      width={"100%"}
                      justifyContent={"flex-start"}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ px: 3 }}
                        color="primary"
                      >
                        {t("SignupCommonField.IBOSignup.FreeSignUpButtonText")}
                      </Button>
                    </Stack>
                  </Stack>
                </form>

                {/* Start Footer */}
                <>
                  <Grid>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      flexWrap={"wrap"}
                      gap={2}
                      width={"100%"}
                      justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                      mt={2}
                    >
                      <Typography variant="body2" color="secondary">
                        <Link
                          href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/PrivacyPolicy.pdf`}
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("SignupCommonField.IBOSignup.PrivacyPolicyLink")}
                        </Link>
                      </Typography>
                      <Typography variant="body2" color="secondary">
                        <Link
                          href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/TermsOfUse.pdf`}
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("SignupCommonField.IBOSignup.TermsOfUseLink")}
                        </Link>
                      </Typography>
                      <Typography variant="body2" color="secondary">
                        <Link
                          href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/MemberTermsAndConditions.pdf`}
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t(
                            "SignupCommonField.IBOSignup.MemberTermsofConditionsLink"
                          )}
                        </Link>
                      </Typography>
                      <Typography variant="body2" color="secondary">
                        <Link href={"/login"} underline="hover" target="_blank">
                          {t("SignupCommonField.IBOSignup.AlreadyMemberLink")}
                        </Link>
                      </Typography>
                    </Stack>
                  </Grid>
                </>
                {/* End Footer */}
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}

      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />

      <FreeSignupNotValidFormPopup
        open={state.invalidFormModel}
        onCloseLogin={() => closeInValidFormLoginPopup()}
        onCloseSignup={(e) => closeInValidFormSignupPopup(e)}
      />

      <SignupCompletePopup
        open={state.signupModel}
        onClose={() => handleDashboard()}
        onCloseIcon={() => {
          navigate("/login");
        }}
      />

      <Menu
        anchorEl={anchorElLanguage}
        open={Boolean(anchorElLanguage)}
        onClose={() => handleLanguageClose()}
      >
        {Object.entries(locales).map(([lang, { title }]) => (
          <MenuItem
            key={lang}
            selected={lang === currentLang}
            onClick={() => {
              handleLanguageClose(lang);
            }}
          >
            {title}
          </MenuItem>
        ))}
      </Menu>
      <GoogleTranslate sx={{pb:2}}/>
    </>
  );
};

export default IBOFreeBYLDerSignup;
